module.exports = __webpack_public_path__ + "static/pic03-b13a1c0386cde618f09fff6a7ccb1a51.jpg";